export const SET_CHECKOUT_LABELS = 'SET_CHECKOUT_LABELS';
export const SET_AS_A_GUEST_EMAIL = 'SET_AS_A_GUEST_EMAIL';
export const SET_CURRENT_STEP_NUMBER = 'SET_CURRENT_STEP_NUMBER';
export const SET_CURRENT_FORM_NAME = 'SET_CURRENT_FORM_NAME';
export const SET_SALUTATIONS = 'SET_SALUTATIONS';
export const SET_PERSONAL_DETAILS_DATA = 'SET_PERSONAL_DETAILS_DATA'; // TODO: Need check necessity this option
export const SET_PERSONAL_DETAILS_FIELD_ERROR = 'SET_PERSONAL_DETAILS_FIELD_ERROR';
export const SET_SHIPPING_DETAILS_CONTINUE = 'SET_SHIPPING_DETAILS_CONTINUE';
export const SET_PICK_UP_AT_DEALER_DISABLED = 'SET_PICK_UP_AT_DEALER_DISABLED';
export const SET_SHIPPING_DETAILS_DATA = 'SET_SHIPPING_DETAILS_DATA';
export const SET_SHIPPING_DETAILS_FIELD_ERROR = 'SET_SHIPPING_DETAILS_FIELD_ERROR';
export const SET_LOQATE_KEY = 'SET_LOQATE_KEY';
export const SET_GOOGLE_KEY = 'SET_GOOGLE_KEY';
export const SET_ACTIVE_PREFER_DEALER = 'SET_ACTIVE_PREFER_DEALER';
export const SET_DEALER_LIST = 'SET_DEALER_LIST';
export const SET_BILLING_ADDRESS_FIELD_ERROR = 'SET_BILLING_ADDRESS_FIELD_ERROR';
export const SET_CREATED_YAMAHA_ACCOUNT = 'SET_CREATED_YAMAHA_ACCOUNT';
export const GET_CONVERT_CART_REQUEST = 'GET_CONVERT_CART_REQUEST';
export const GET_CONVERT_CART_SUCCESS = 'GET_CONVERT_CART_SUCCESS';
export const GET_CONVERT_CART_FAILURE = 'GET_CONVERT_CART_FAILURE';
export const SET_ORDER_REVIEW_MODEL = 'SET_ORDER_REVIEW_MODEL';
export const SET_BILLING_ADDRESS_DATA = 'SET_BILLING_ADDRESS_DATA';
export const SET_SAME_AS_SHIPPING_ADDRESS = 'SET_SAME_AS_SHIPPING_ADDRESS';
export const SET_SHIPPING_DETAILS_EMAIL_ERROR = 'SET_SHIPPING_DETAILS_EMAIL_ERROR';
export const SET_PAYMENT_SESSION = 'SET_PAYMENT_SESSION';
export const SET_PAYMENT_SUCCESS = 'SET_PAYMENT_SUCCESS';
export const SET_PAYMENT_ERRORS = 'SET_PAYMENT_ERRORS';
export const SET_BILLING_OPTION = 'SET_BILLING_OPTION';
export const SET_DEALERS_TOOLS = 'SET_DEALERS_TOOLS';
export const SET_ORDER_REVIEW_STATUS = 'SET_ORDER_REVIEW_STATUS';
export const SET_ADDRESS_CONFIG = 'SET_ADDRESS_CONFIG';
export const SET_PAYMENT_PROVIDER = 'SET_PAYMENT_PROVIDER';
export const SET_BILLING_COUNTRIES = 'SET_BILLING_COUNTRIES';
export const SET_BILLING_STATES = 'SET_BILLING_STATES';
export const SET_CHECKOUT_LOGIN = 'SET_CHECKOUT_LOGIN';
export const SET_PAYEVER_CONFIG_MODEL = 'SET_PAYEVER_CONFIG_MODEL';
export const SET_BILLING_AND_DEALERS_ORDER = 'SET_BILLING_AND_DEALERS_ORDER';
export const SET_EXCLUSION_POSTAL_CODE = 'SET_EXCLUSION_POSTAL_CODE';
